import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// Function to create routes
export function createRouter () {
  return new Router({
    base: process.env.VUE_APP_RELATIVE_PATH || '/',
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
      { path: '/', name: 'home', component: () => import(/* webpackChunkName: "home" */ '../pages/HomeView') },
      { path: '/select', name: 'selectProfile', component: () => import(/* webpackChunkName: "select" */ '../pages/SelectView') }
    ]
  })
}
